var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1225.3 363",
    style: {
      enableBackground: "new 0 0 1225.3 363"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:3.7037;stroke-miterlimit:185.1852;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{opacity:0.2;enable-background:new    ;}\n\t.st7{opacity:0.12;enable-background:new    ;}\n\t.st8{opacity:0.25;fill:#FFFFFF;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1179.9,363H45.4C20,363,0,343.1,0,317.7V45.4C0,20,20,0,45.4,0h1134.5c25.4,0,45.4,20,45.4,45.4v272.3 C1225.3,343.1,1205.3,363,1179.9,363z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.2,92.6c0,7.3-1.8,13.6-6.4,18.2c-5.4,5.4-11.8,8.2-20,8.2s-14.5-2.7-20-8.2c-5.4-5.4-8.2-11.8-8.2-20 s2.7-14.5,8.2-20c5.4-5.4,11.8-8.2,20-8.2c3.6,0,7.3,0.9,10.9,2.7c3.6,1.8,6.4,3.6,8.2,6.4l-4.5,4.5c-3.6-4.5-8.2-6.4-14.5-6.4 c-5.4,0-10.9,1.8-14.5,6.4c-4.5,3.6-6.4,9.1-6.4,15.4c0,6.4,1.8,11.8,6.4,15.4c4.5,3.6,9.1,6.4,14.5,6.4c6.4,0,10.9-1.8,15.4-6.4 c2.7-2.7,4.5-6.4,4.5-10.9h-20v-7.3h26.3L430.2,92.6L430.2,92.6z M472,69.9h-24.5v17.2h22.7v6.4h-22.7v17.2H472v7.3h-31.8V63.5H472 V69.9z M501.9,118h-7.3V69.9h-15.4v-6.4h38.1v6.4h-15.4V118z M543.7,118V63.5h7.3V118H543.7z M581.8,118h-7.3V69.9h-15.4v-6.4h37.2 v6.4h-15.4V118H581.8z M668,110.7c-5.4,5.4-11.8,8.2-20,8.2s-14.5-2.7-20-8.2c-5.4-5.4-8.2-11.8-8.2-20s2.7-14.5,8.2-20 c5.4-5.4,11.8-8.2,20-8.2s14.5,2.7,20,8.2c5.4,5.4,8.2,11.8,8.2,20S673.4,105.3,668,110.7z M633.5,106.2c3.6,3.6,9.1,6.4,14.5,6.4 s10.9-1.8,14.5-6.4c3.6-3.6,6.4-9.1,6.4-15.4s-1.8-11.8-6.4-15.4c-3.6-3.6-9.1-6.4-14.5-6.4s-10.9,1.8-14.5,6.4 c-3.6,3.6-6.4,9.1-6.4,15.4S629,102.6,633.5,106.2z M686.2,118V63.5h8.2l26.3,42.7V63.5h7.3V118h-7.3l-28.1-44.5V118H686.2 L686.2,118z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M618.1,197.9c-21.8,0-39,16.3-39,39c0,21.8,17.2,39,39,39s39-16.3,39-39C657.1,213.3,639.9,197.9,618.1,197.9z  M618.1,259.6c-11.8,0-21.8-10-21.8-23.6s10-23.6,21.8-23.6s21.8,9.1,21.8,23.6C639.9,249.6,629.9,259.6,618.1,259.6z M533.7,197.9 c-21.8,0-39,16.3-39,39c0,21.8,17.2,39,39,39s39-16.3,39-39C572.7,213.3,555.5,197.9,533.7,197.9z M533.7,259.6 c-11.8,0-21.8-10-21.8-23.6s10-23.6,21.8-23.6s21.8,9.1,21.8,23.6C555.5,249.6,545.5,259.6,533.7,259.6z M432.9,209.7V226h39 c-0.9,9.1-4.5,16.3-9.1,20.9c-5.4,5.4-14.5,11.8-30,11.8c-24.5,0-42.7-19.1-42.7-43.6s19.1-43.6,42.7-43.6c12.7,0,22.7,5.4,30,11.8 l11.8-11.8c-10-9.1-22.7-16.3-40.8-16.3c-32.7,0-60.8,27.2-60.8,59.9s28.1,59.9,60.8,59.9c18.2,0,30.9-5.4,41.8-17.2 c10.9-10.9,14.5-26.3,14.5-38.1c0-3.6,0-7.3-0.9-10L432.9,209.7L432.9,209.7z M845,222.4c-3.6-9.1-12.7-24.5-32.7-24.5 s-36.3,15.4-36.3,39c0,21.8,16.3,39,38.1,39c17.2,0,28.1-10.9,31.8-17.2l-12.7-9.1c-4.5,6.4-10,10.9-19.1,10.9s-14.5-3.6-19.1-11.8 l51.7-21.8L845,222.4L845,222.4z M792.3,235.1c0-14.5,11.8-22.7,20-22.7c6.4,0,12.7,3.6,14.5,8.2L792.3,235.1L792.3,235.1z  M749.7,272.3h17.2V158.8h-17.2V272.3z M722.5,206c-4.5-4.5-11.8-9.1-20.9-9.1c-19.1,0-37.2,17.2-37.2,39s17.2,38.1,37.2,38.1 c9.1,0,16.3-4.5,20-9.1h0.9v5.4c0,14.5-8.2,22.7-20.9,22.7c-10,0-17.2-7.3-19.1-13.6l-14.5,6.4c4.5,10,15.4,22.7,34.5,22.7 c20,0,36.3-11.8,36.3-39.9v-69h-16.3V206L722.5,206z M702.5,259.6c-11.8,0-21.8-10-21.8-23.6s10-23.6,21.8-23.6s20.9,10,20.9,23.6 S714.3,259.6,702.5,259.6z M923.9,158.8h-40.8v113.5h17.2v-42.7h23.6c19.1,0,37.2-13.6,37.2-35.4S943,158.8,923.9,158.8z  M924.9,213.3h-24.5v-39h24.5c12.7,0,20,10.9,20,19.1C943.9,203.3,936.7,213.3,924.9,213.3L924.9,213.3z M1029.2,197 c-12.7,0-25.4,5.4-30,17.2l15.4,6.4c3.6-6.4,9.1-8.2,15.4-8.2c9.1,0,17.2,5.4,18.2,14.5v0.9c-2.7-1.8-10-4.5-17.2-4.5 c-16.3,0-32.7,9.1-32.7,25.4c0,15.4,13.6,25.4,28.1,25.4c11.8,0,17.2-5.4,21.8-10.9h0.9v9.1h16.3v-43.6 C1063.7,208.8,1048.3,197,1029.2,197L1029.2,197z M1027.4,259.6c-5.4,0-13.6-2.7-13.6-10c0-9.1,10-11.8,18.2-11.8 c7.3,0,10.9,1.8,15.4,3.6C1045.6,252.3,1036.5,259.6,1027.4,259.6z M1122.7,199.7l-19.1,49h-0.9l-20-49h-18.2l30,69l-17.2,38.1h17.2 l46.3-107.1L1122.7,199.7L1122.7,199.7z M970.2,272.3h17.2V158.8h-17.2V272.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1201.6975,
    y1: 167.0173,
    x2: 1193.472,
    y2: 158.7923,
    gradientTransform: "matrix(18.5185 0 0 -18.5185 -22055.8086 3171.9392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007000001,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.4,68.1c-2.7,2.7-3.6,7.3-3.6,12.7v200.6c0,5.4,1.8,10,4.5,12.7l0.9,0.9l112.5-112.5v-1.8L94.4,68.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1207.5963,
    y1: 161.4596,
    x2: 1195.7372,
    y2: 161.4596,
    gradientTransform: "matrix(18.5185 0 0 -18.5185 -22055.8086 3171.9392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M245.1,220.5l-37.2-37.2v-2.7l37.2-37.2l0.9,0.9l44.5,25.4c12.7,7.3,12.7,19.1,0,26.3L245.1,220.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1203.1774,
    y1: 160.3624,
    x2: 1192.0234,
    y2: 149.2085,
    gradientTransform: "matrix(18.5185 0 0 -18.5185 -22055.8086 3171.9392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M246,219.6l-38.1-38.1L94.4,295c4.5,4.5,10.9,4.5,19.1,0.9L246,219.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1194.5735,
    y1: 171.1823,
    x2: 1199.5544,
    y2: 166.2013,
    gradientTransform: "matrix(18.5185 0 0 -18.5185 -22055.8086 3171.9392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M246,143.4L113.5,68.1c-8.2-4.5-14.5-3.6-19.1,0.9l113.5,112.5L246,143.4L246,143.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M245.1,218.7l-131.6,74.4c-7.3,4.5-13.6,3.6-18.2,0l-0.9,0.9l0.9,0.9c4.5,3.6,10.9,4.5,18.2,0L245.1,218.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M94.4,293.2c-2.7-2.7-3.6-7.3-3.6-12.7v0.9c0,5.4,1.8,10,4.5,12.7v-0.9H94.4L94.4,293.2z M290.4,193.3 L245,218.7l0.9,0.9l44.5-25.4c6.4-3.6,9.1-8.2,9.1-12.7C299.5,186.1,295.9,189.7,290.4,193.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M113.5,69l177,100.7c5.4,3.6,9.1,7.3,9.1,11.8c0-4.5-2.7-9.1-9.1-12.7l-177-100.7 c-12.7-7.3-22.7-1.8-22.7,12.7v0.9C90.8,68.1,100.7,61.7,113.5,69z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.c96333b03a8ee853839d65dffba7ccda.svg";
export { ForwardRef as ReactComponent };